import { render, staticRenderFns } from "./strategyList.vue?vue&type=template&id=3832f23b"
import script from "./strategyList.vue?vue&type=script&lang=js"
export * from "./strategyList.vue?vue&type=script&lang=js"
import style0 from "./strategyList.vue?vue&type=style&index=0&id=3832f23b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports